// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaysActivity {
  width: 100%;
  height: 54px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  /* background-color: #efeeed;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5); */
  background-color: white;
  border: solid 1px #dee0e1;
  border-radius: 50px;
  cursor: pointer;
  padding: 5px 10px;
}

@media screen and (min-width: 768px) {
  .SaysActivity {
    width: 370px;
  }
}
@media screen and (min-width: 1024px) {
  .SaysActivity {
    width: 480px;
  }
}

.usable-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.AskActivity_active {
  width: 100%;
  height: 625px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #fefefe;
  border-radius: 20px;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5);
  cursor: pointer;
  overflow: hidden;
  padding: 5px 10px;
  margin-bottom: 15px;
  margin-top: 30px;
}
.color-combination {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 54px;
  background-color: #fefefe;
  border-radius: 20px;
  cursor: pointer;
  padding: 5px 10px;
}

@media screen and (min-width: 768px) {
  .AskActivity_active {
    width: 375px;
    height: 625px;
    margin-top: 30px !important;
  }
}

@media screen and (min-width: 1024px) {
  .AskActivity_active {
    width: 480px;
    height: 625px;
  }
}
.ActivityInfo {
  width: 50%;
  padding-top: 15px;
  margin-right: 20px;
}
.number {
  margin-left: 180px;
}
.posts {
  width: 470px;
  height: 589px;
  margin-top: 30px;
  padding: 20px 0px;
  border-radius: 20px;
  background-color: white;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5);
  overflow-y: scroll;
  margin-bottom: 18px;

  scrollbar-width: thin; /* Set the width of the scrollbar for Firefox */
}

.posts {
  scrollbar-color: #707070 transparent; /* Set the color of the scrollbar thumb for Firefox */
}

/* WebKit (Chrome, Safari, etc.) */
.posts::-webkit-scrollbar {
  width: 4px; /* Set the width of the scrollbar for WebKit browsers */
}

.posts::-webkit-scrollbar-thumb {
  background-color: #707070;
  border-radius: 8px;
}

.posts::-webkit-scrollbar-track {
  background-color: transparent; /* Set the scrollbar track color to transparent */
  border-radius: 8px; /* Set the border-radius for the main container */
}

.post-1 {
  width: 95%;
  min-height: 100px;
  overflow-wrap: break-word;
  margin: 10px auto;
  padding: 10px;
  /* border:1px solid red; */
  border-radius: 20px;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5);
  position: relative;
  background-color: #f3f2f0c3;
}
.profile-info {
  display: flex;
  height: 45px;
  /* border:1px solid yellow;  */
}
.profile-info p {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin: 0 10px;
}
.profile-info span {
  width: 100%;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.7);
  /* margin: 0 10px; */
  /* border:1px solid ;  */
}
/* .discrpition {
  margin-top: 20px;
  overflow-wrap: break-word;
} */
.MessgeDetils {
  /* border:1px solid red; */
  margin-left: 10px;
}
/* .discrpition p {
  width: 428px;
  margin: 0;
  margin-top: 3px;
} */
.PostActions {
  margin-top: 5px;
  border-top: 1px solid #979595;
  /* font-size: 18px; */
  font-weight: 400;
}
.PostActions--Following {
  display: flex;
  justify-content: space-around;
  font-size: 14px;
}
.PostCounts {
  margin-top: 5px;
  font-size: 12px;
  color: #373334;
}

.PostActions img {
  margin-right: 2px;
}
.answer-icon {
  margin: 0px 5px 0px 20px;
  height: 30px;
}
.reply-icon {
  margin: 0px 10px 0px 23px;
  height: 21px;
}
.LikeUpadte {
  margin-top: 15px;
  font-size: 12px;
}
.warning-msg-text {
  color: red;
  margin-top: -10px;
  margin-bottom: 1px;
}

.cursor-pointer {
  cursor: pointer !important;
}
.cursor-not-allowed {
  cursor: not-allowed !important;
}

/* .postsDownArrow {
  margin-top: 20px;
  margin-left: 150px;
  width: 10px;
  height: 5px;
} */
/* .inner-dropdown {
  position: absolute;
  right: -3px;
  top: 70px;
  width: 266px;
  height: 100px;
  border-radius: 30px;
  background-color: ivory;
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 10px;
  display: "block";
} */

/* .inner-dropdown img {
  margin-right: 10px;
} */
/* .inner-dropdown div {
  margin-bottom: 10px;
  cursor: pointer;
} */
.Sepator {
  border-top: 1px solid;
}
/* @media (max-width: 768px) {
  .SaysActivity {
    width: 380px;
  }
  .posts {
    width: 380px;
  }
  .post-1 {
    width: 350px;
  }
}
@media (max-width: 320px) {
  .SaysActivity {
    width: 320px;
  }
  .posts {
    width: 320px;
  }
  .post-1 {
    width: 290px;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Activites/ReplyActivity/ReplyActivity.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB;;8CAE4C;EAC5C,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB;2CACyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB;2CACyC;EACzC,kBAAkB;EAClB,mBAAmB;;EAEnB,qBAAqB,EAAE,+CAA+C;AACxE;;AAEA;EACE,oCAAoC,EAAE,qDAAqD;AAC7F;;AAEA,kCAAkC;AAClC;EACE,UAAU,EAAE,uDAAuD;AACrE;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B,EAAE,iDAAiD;EAChF,kBAAkB,EAAE,iDAAiD;AACvE;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB;2CACyC;EACzC,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;;;GAGG;AACH;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;;;;GAIG;AACH;EACE,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;;AAEA;;;;;GAKG;AACH;;;;;;;;;;;;GAYG;;AAEH;;GAEG;AACH;;;GAGG;AACH;EACE,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;GAqBG","sourcesContent":[".SaysActivity {\r\n  width: 100%;\r\n  height: 54px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 30px;\r\n  /* background-color: #efeeed;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n  background-color: white;\r\n  border: solid 1px #dee0e1;\r\n  border-radius: 50px;\r\n  cursor: pointer;\r\n  padding: 5px 10px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .SaysActivity {\r\n    width: 370px;\r\n  }\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .SaysActivity {\r\n    width: 480px;\r\n  }\r\n}\r\n\r\n.usable-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.AskActivity_active {\r\n  width: 100%;\r\n  height: 625px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  background-color: #fefefe;\r\n  border-radius: 20px;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n  padding: 5px 10px;\r\n  margin-bottom: 15px;\r\n  margin-top: 30px;\r\n}\r\n.color-combination {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 54px;\r\n  background-color: #fefefe;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n  padding: 5px 10px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .AskActivity_active {\r\n    width: 375px;\r\n    height: 625px;\r\n    margin-top: 30px !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .AskActivity_active {\r\n    width: 480px;\r\n    height: 625px;\r\n  }\r\n}\r\n.ActivityInfo {\r\n  width: 50%;\r\n  padding-top: 15px;\r\n  margin-right: 20px;\r\n}\r\n.number {\r\n  margin-left: 180px;\r\n}\r\n.posts {\r\n  width: 470px;\r\n  height: 589px;\r\n  margin-top: 30px;\r\n  padding: 20px 0px;\r\n  border-radius: 20px;\r\n  background-color: white;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n  overflow-y: scroll;\r\n  margin-bottom: 18px;\r\n\r\n  scrollbar-width: thin; /* Set the width of the scrollbar for Firefox */\r\n}\r\n\r\n.posts {\r\n  scrollbar-color: #707070 transparent; /* Set the color of the scrollbar thumb for Firefox */\r\n}\r\n\r\n/* WebKit (Chrome, Safari, etc.) */\r\n.posts::-webkit-scrollbar {\r\n  width: 4px; /* Set the width of the scrollbar for WebKit browsers */\r\n}\r\n\r\n.posts::-webkit-scrollbar-thumb {\r\n  background-color: #707070;\r\n  border-radius: 8px;\r\n}\r\n\r\n.posts::-webkit-scrollbar-track {\r\n  background-color: transparent; /* Set the scrollbar track color to transparent */\r\n  border-radius: 8px; /* Set the border-radius for the main container */\r\n}\r\n\r\n.post-1 {\r\n  width: 95%;\r\n  min-height: 100px;\r\n  overflow-wrap: break-word;\r\n  margin: 10px auto;\r\n  padding: 10px;\r\n  /* border:1px solid red; */\r\n  border-radius: 20px;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n  position: relative;\r\n  background-color: #f3f2f0c3;\r\n}\r\n.profile-info {\r\n  display: flex;\r\n  height: 45px;\r\n  /* border:1px solid yellow;  */\r\n}\r\n.profile-info p {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #333;\r\n  margin: 0 10px;\r\n}\r\n.profile-info span {\r\n  width: 100%;\r\n  font-size: 12px;\r\n  color: rgba(0, 0, 0, 0.7);\r\n  /* margin: 0 10px; */\r\n  /* border:1px solid ;  */\r\n}\r\n/* .discrpition {\r\n  margin-top: 20px;\r\n  overflow-wrap: break-word;\r\n} */\r\n.MessgeDetils {\r\n  /* border:1px solid red; */\r\n  margin-left: 10px;\r\n}\r\n/* .discrpition p {\r\n  width: 428px;\r\n  margin: 0;\r\n  margin-top: 3px;\r\n} */\r\n.PostActions {\r\n  margin-top: 5px;\r\n  border-top: 1px solid #979595;\r\n  /* font-size: 18px; */\r\n  font-weight: 400;\r\n}\r\n.PostActions--Following {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  font-size: 14px;\r\n}\r\n.PostCounts {\r\n  margin-top: 5px;\r\n  font-size: 12px;\r\n  color: #373334;\r\n}\r\n\r\n.PostActions img {\r\n  margin-right: 2px;\r\n}\r\n.answer-icon {\r\n  margin: 0px 5px 0px 20px;\r\n  height: 30px;\r\n}\r\n.reply-icon {\r\n  margin: 0px 10px 0px 23px;\r\n  height: 21px;\r\n}\r\n.LikeUpadte {\r\n  margin-top: 15px;\r\n  font-size: 12px;\r\n}\r\n.warning-msg-text {\r\n  color: red;\r\n  margin-top: -10px;\r\n  margin-bottom: 1px;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer !important;\r\n}\r\n.cursor-not-allowed {\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n/* .postsDownArrow {\r\n  margin-top: 20px;\r\n  margin-left: 150px;\r\n  width: 10px;\r\n  height: 5px;\r\n} */\r\n/* .inner-dropdown {\r\n  position: absolute;\r\n  right: -3px;\r\n  top: 70px;\r\n  width: 266px;\r\n  height: 100px;\r\n  border-radius: 30px;\r\n  background-color: ivory;\r\n  padding-top: 10px;\r\n  padding-left: 20px;\r\n  padding-right: 10px;\r\n  display: \"block\";\r\n} */\r\n\r\n/* .inner-dropdown img {\r\n  margin-right: 10px;\r\n} */\r\n/* .inner-dropdown div {\r\n  margin-bottom: 10px;\r\n  cursor: pointer;\r\n} */\r\n.Sepator {\r\n  border-top: 1px solid;\r\n}\r\n/* @media (max-width: 768px) {\r\n  .SaysActivity {\r\n    width: 380px;\r\n  }\r\n  .posts {\r\n    width: 380px;\r\n  }\r\n  .post-1 {\r\n    width: 350px;\r\n  }\r\n}\r\n@media (max-width: 320px) {\r\n  .SaysActivity {\r\n    width: 320px;\r\n  }\r\n  .posts {\r\n    width: 320px;\r\n  }\r\n  .post-1 {\r\n    width: 290px;\r\n  }\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
